const getHiddenParameterOption = (param, data) => {
  let data_value = data.parametros_portal[param.parameter];
  if (data_value) {
    let filterValue = param.options.filter((i) => i.value_of == data_value);
    if (filterValue.length > 0) {
      return filterValue[0].value;
    }
  }
  return null;
};

const processHiddenParameterOption = (param, data) => {
  let value_option = getHiddenParameterOption(param, data);

  if (value_option == null) return data;

  if (param.extra_key) {
    if (data["parametros_extra"] == undefined) {
      data["parametros_extra"] = {};
    }
    if (data["parametros_extra"][param.extra_key] == undefined) {
      data["parametros_extra"][param.extra_key] = {};
    }
    data["parametros_extra"][param.extra_key][param.name] = value_option;
  } else {
    data["parametros_portal"][param.name] = value_option;
  }
  return data;
};

const getParametrosExtra = (modeloParametrosPortal, data) => {
  if(modeloParametrosPortal && modeloParametrosPortal.fields instanceof Array) {
    return modeloParametrosPortal.fields.reduce((acc, field) => {
      if (field.extra_key) {
        const extraKeyDict = acc[field.extra_key] || {};
        acc[field.extra_key] = {
          ...extraKeyDict,
          [field.name]: data.parametros_portal[field.name]
        }
      }
      return acc
    }, {})
  }
  return {}
}

const parameterService = {
  getHiddenParameterOption,
  processHiddenParameterOption,
  getParametrosExtra
};

export default parameterService;
